import React, { Component } from 'react';
import styled from 'styled-components';

import mediaWidth from '../../../utils/mediaWidth/mediaWidth';

import Button from './Button';

class Buttons extends Component {
    render() {
        const {
            className,
            quantity,
            currentIndex,
            onClick,
        } = this.props;
        return (
            <StyledButtons className={className}>
                {
                    Array(+quantity).fill(null).map((_, i) => (
                        <Button
                            key={i.toString()}
                            isFilled={i === currentIndex}
                            onClick={() => onClick(i)}
                        />
                    ))
                }
            </StyledButtons>
        );
    }
}

const StyledButtons = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 34px;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.16) 100%);

    div:nth-child(n+1) {
        margin-left: 8px;
    };

    ${mediaWidth.m} {
        height: 42px;
    };
`;

export default Buttons;
